import React, { useState } from "react";
import {
  BottomNavigation,
  BottomNavigationAction,
  Paper,
  Container,
  useMediaQuery,
} from "@mui/material";
import HomeIcon from "@mui/icons-material/Home";
import ImageIcon from "@mui/icons-material/Image";
import InfoIcon from "@mui/icons-material/Info";

type BottomMenuProps = {
  onItemClick?: (index: number) => void;
};

const BottomMenu: React.FC<BottomMenuProps> = ({ onItemClick }) => {
  const [value, setValue] = useState(0);
  const isCompact = useMediaQuery("(max-width:1024px)");

  return (
    <Paper
      sx={{
        position: isCompact ? "fixed" : "absolute",
        bottom: 0,
        left: 0,
        right: 0,
        width: "100%",
        display: "flex",
        justifyContent: "center",
        zIndex: 1300, // asegúrate de que esté sobre el contenido
        borderRadius: isCompact ? 0 : 2,
      }}
      elevation={3}
    >
      <Container maxWidth="md" disableGutters>
        <BottomNavigation
          showLabels
          value={value}
          onChange={(_, newValue) => {
            setValue(newValue);
            if (onItemClick) {
              onItemClick(newValue);
            }
          }}
        >
          <BottomNavigationAction label="Inicio" icon={<HomeIcon />} />
          <BottomNavigationAction label="Información" icon={<InfoIcon />} />
          <BottomNavigationAction label="Galería" icon={<ImageIcon />} />
        </BottomNavigation>
      </Container>
    </Paper>
  );
};

export default BottomMenu;
